export default [
  {
    path: '/food',
    name: 'food',
    component: () => import('@/views/menu/food/food.vue'),
    meta: {
      pageTitle: 'مدیریت غذا',
      action: 'show',
      resource: 'FoodManager',
    },
  },
  {
    path: '/food/details',
    name: 'addfood',
    component: () => import('@/views/menu/food/fooddetails.vue'),
    meta: {
      pageTitle: 'ایجاد غذا',
      action: 'show',
      resource: 'FoodManager',
    },
  },
  {
    path: '/food/details/:id',
    name: 'updatefood',
    component: () => import('@/views/menu/food/fooddetails.vue'),
    meta: {
      pageTitle: 'ویرایش غذ',
      action: 'show',
      resource: 'FoodManager',
    },
  },
  {
    path: '/foodrecipes',
    name: 'foodrecipes',
    component: () => import('@/views/menu/food/foodrecipes.vue'),
    meta: {
      pageTitle: 'مدیریت دستور پخت',
      action: 'show',
      resource: 'FoodRecipesManager',
    },
  },
  {
    path: '/foodrecipes/details',
    name: 'addfoodrecipes',
    component: () => import('@/views/menu/food/foodrecipesdetails.vue'),
    meta: {
      pageTitle: 'ایجاد دستور پخت',
      action: 'show',
      resource: 'FoodManager',
    },
  },
  {
    path: '/foodrecipes/details/:id',
    name: 'updatefoodrecipes',
    component: () => import('@/views/menu/food/foodrecipesdetails.vue'),
    meta: {
      pageTitle: 'ویرایش دستور پخت',
      action: 'show',
      resource: 'FoodManager',
    },
  },
  {
    path: '/foodrecipescomment',
    name: 'foodrecipescomment',
    component: () => import('@/views/menu/food/foodrecipescomment.vue'),
    meta: {
      pageTitle: 'مدیریت دستور پخت',
      action: 'show',
      resource: 'FoodRecipesCommentManager',
    },
  },
  {
    path: '/foodmeal',
    name: 'foodmeal',
    component: () => import('@/views/menu/food/foodmeal.vue'),
    meta: {
      pageTitle: 'مدیریت وعده غذا',
      action: 'show',
      resource: 'FoodMealManager',
    },
  },
  {
    path: '/foodmeal/details',
    name: 'addfoodmeal',
    component: () => import('@/views/menu/food/foodmealdetails.vue'),
    meta: {
      pageTitle: 'ایجاد وعده غذا',
      action: 'show',
      resource: 'FoodMealManager',
    },
  },
  {
    path: '/foodmeal/details/:id',
    name: 'updatefoodmeal',
    component: () => import('@/views/menu/food/foodmealdetails.vue'),
    meta: {
      pageTitle: 'ویرایش وعده غذ',
      action: 'show',
      resource: 'FoodMealManager',
    },
  },
  {
    path: '/foodcategory',
    name: 'foodcategory',
    component: () => import('@/views/menu/food/foodcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی غذا',
      action: 'show',
      resource: 'FoodCategoryManager',
    },
  },
  {
    path: '/foodcategory/details',
    name: 'addfoodcategory',
    component: () => import('@/views/menu/food/foodcategorydetails.vue'),
    meta: {
      pageTitle: 'فرم وعده',
      action: 'show',
      resource: 'FoodCategoryManager',
    },
  },
  {
    path: '/foodcategory/details/:id',
    name: 'updatefoodcategory',
    component: () => import('@/views/menu/food/foodcategorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش وعده غذ',
      action: 'show',
      resource: 'FoodCategoryManager',
    },
  },
  {
    path: '/foodunit',
    name: 'foodunit',
    component: () => import('@/views/menu/food/foodunit.vue'),
    meta: {
      pageTitle: 'مدیریت واحد غذا',
      action: 'show',
      resource: 'FoodUnitManager',
    },
  },
  {
    path: '/foodunit/details',
    name: 'addfoodunit',
    component: () => import('@/views/menu/food/foodunitdetails.vue'),
    meta: {
      pageTitle: 'ایجاد وعده غذا',
      action: 'show',
      resource: 'FoodUnitManager',
    },
  },
  {
    path: '/foodunit/details/:id',
    name: 'updatefoodunit',
    component: () => import('@/views/menu/food/foodunitdetails.vue'),
    meta: {
      pageTitle: 'ویرایش واحد غذ',
      action: 'show',
      resource: 'FoodUnitManager',
    },
  },
  {
    path: '/foodindicator',
    name: 'foodindicator',
    component: () => import('@/views/menu/food/foodindicator.vue'),
    meta: {
      pageTitle: 'مدیریت شاخص ها',
      action: 'show',
      resource: 'FoodIndicatorManager',
    },
  },
  {
    path: '/foodindicator/details',
    name: 'addfoodindicator',
    component: () => import('@/views/menu/food/foodindicatordetails.vue'),
    meta: {
      pageTitle: 'ایجاد شاخص',
      action: 'show',
      resource: 'FoodIndicatorManager',
    },
  },
  {
    path: '/foodindicator/details/:id',
    name: 'updatefoodindicator',
    component: () => import('@/views/menu/food/foodindicatordetails.vue'),
    meta: {
      pageTitle: 'ویرایش شاخص',
      action: 'show',
      resource: 'FoodIndicatorManager',
    },
  },
  {
    path: '/foodsuggestion',
    name: 'foodsuggestion',
    component: () => import('@/views/menu/food/foodsuggestion.vue'),
    meta: {
      pageTitle: 'مدیریت شاخص ها',
      action: 'show',
      resource: 'FoodIndicatorManager',
    },
  },
  {
    path: '/foodsuggestion/details/:id',
    name: 'updatefoodsuggestion',
    component: () => import('@/views/menu/food/foodsuggestiondetails.vue'),
    meta: {
      pageTitle: 'ویرایش شاخص',
      action: 'show',
      resource: 'FoodIndicatorManager',
    },
  },
  {
    path: '/foodlist',
    name: 'foodlist',
    component: () => import('@/views/menu/food/foodlist.vue'),
    meta: {
      pageTitle: 'مدیریت لیست های غذایی',
      action: 'show',
      resource: 'FoodListManager',
    },
  },
  {
    path: '/foodlist/details',
    name: 'addfoodlist',
    component: () => import('@/views/menu/food/foodlistdetails.vue'),
    meta: {
      pageTitle: 'ایجاد لیست غذا',
      action: 'show',
      resource: 'FoodListManager',
    },
  },
  {
    path: '/foodlist/duplicate/:id',
    name: 'duplicatefoodlist',
    component: () => import('@/views/menu/food/foodlistdetails.vue'),
    meta: {
      pageTitle: 'ایجاد لیست غذا',
      action: 'show',
      resource: 'FoodListManager',
    },
  },
  {
    path: '/foodlist/details/:id',
    name: 'updatefoodlist',
    component: () => import('@/views/menu/food/foodlistdetails.vue'),
    meta: {
      pageTitle: 'ویرایش لیست غذا',
      action: 'show',
      resource: 'FoodListManager',
    },
  },
  {
    path: '/foodcomment',
    name: 'foodcomment',
    component: () => import('@/views/menu/food/foodcomment.vue'),
    meta: {
      pageTitle: 'مدیریت نظرها',
      action: 'show',
      resource: 'FoodCommentManager',
    },
  },
]
